import ListProcesses from "@/views/open_queries/organization/basic_production/process/ListProcesses.vue";
import ShowProduction from "@/views/open_queries/organization/basic_production/process/ShowProduction.vue";

const ROLE = "basic_production";
const PERMISSION = "process";
const ROUTE_NAME_PREFIX = `oq_organization_${ROLE}_${PERMISSION}`;
const META = {
  role: ROLE,
  permission: PERMISSION
};
export default [
  /**
   * REVIEW: ¿Usar redireccion o usar estrutura org_role_permission_path en el nombre?
   * La primera ruta siempre redirige a la raiz del modulo que corresponde a la segunda
   * se hace esto porque en el menu no se sabe cual es el sufijo del nombre path para la combinacion role-permission
   * siguiendo la estructura org_role_permission_sufix_path que tiene el nombre de las demas rutas
   */
  {
    path: "/oq/organization/:organization_id/basic_production/process/list",
    name: `org_${ROLE}_${PERMISSION}_path`,
    redirect: { name: `${ROUTE_NAME_PREFIX}_list_processes_path` }
  },
  {
    path: "/oq/organization/:organization_id/basic_production/process/list",
    name: `${ROUTE_NAME_PREFIX}_list_processes_path`,
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/oq/organization/:organization_id/basic_production/process/:harvest_process_id/show",
    name: `${ROUTE_NAME_PREFIX}_show_production_path`,
    component: ShowProduction,
    props: true,
    meta: META
  }
];
